<template>
  <div class="pay-success-container">
    <div class="pay-success-card">
      <div class="success-icon">✓</div>
      <h2>支付成功</h2>
      <p>您的订单已支付成功，感谢您的购买！</p>

      <div class="order-summary" v-if="planName">
        <div class="summary-row">
          <span class="label">订阅方案：</span>
          <span class="value">{{ planName }}</span>
        </div>
        <div class="summary-row">
          <span class="label">支付金额：</span>
          <span class="value amount">¥{{ price }}</span>
        </div>
        <div class="summary-row">
          <span class="label">订单号：</span>
          <span class="value order-no">{{ orderNo }}</span>
        </div>
      </div>

      <div class="success-buttons">
        <button class="btn primary" @click="goToHome">返回首页</button>
        <button class="btn second" @click="goToProfile">个人中心</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  data() {
    return {
      planName: '',
      price: 0,
      orderNo: ''
    }
  },
  mounted() {
    this.planName = this.$route.query.plan || ''
    this.price = this.$route.query.price || 0
    this.orderNo = this.$route.query.orderNo || ''
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    goToProfile() {
      this.$router.push('/profile')
    }
  }
}
</script>

<style scoped>
.pay-success-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0d0f16;
  padding: 20px;
}

.pay-success-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 48px 40px;
  text-align: center;
  max-width: 440px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.success-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #00e6ac, #00c292);
  color: #0a192f;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  font-weight: bold;
  margin: 0 auto 24px;
  box-shadow: 0 8px 24px rgba(0, 230, 172, 0.3);
}

.pay-success-card h2 {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
}

.pay-success-card p {
  color: #8892b0;
  margin-bottom: 28px;
  font-size: 15px;
}

.order-summary {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 28px;
  text-align: left;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
}

.summary-row:not(:last-child) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.summary-row .label {
  color: #8892b0;
}

.summary-row .value {
  color: #e6f1ff;
  font-weight: 500;
}

.summary-row .value.amount {
  color: #00e6ac;
  font-size: 18px;
  font-weight: 700;
}

.summary-row .value.order-no {
  font-family: monospace;
  font-size: 13px;
  color: #a8b2d1;
}

.success-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn {
  padding: 14px 28px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn.primary {
  background: linear-gradient(135deg, #00e6ac, #00c292);
  color: #0a192f;
}

.btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 230, 172, 0.3);
}

.btn.second {
  background: rgba(255, 255, 255, 0.05);
  color: #e6f1ff;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn.second:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .pay-success-card {
    padding: 36px 24px;
  }

  .success-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}
</style>
